import { Navigate, useParams } from 'react-router-dom'

/** A location's AI Agent configuration moved to Agents → Settings, opened on that location. */
export default function LocationConfigurationRedirect() {
  const { locationId } = useParams()
  return <Navigate to={`/agents/settings?locationId=${encodeURIComponent(locationId ?? ``)}`} replace />
}
